/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CompetitionUpdateCompetitionParam model module.
 * @module model/CompetitionUpdateCompetitionParam
 * @version 1.0
 */
class CompetitionUpdateCompetitionParam {
    /**
     * Constructs a new <code>CompetitionUpdateCompetitionParam</code>.
     * @alias module:model/CompetitionUpdateCompetitionParam
     */
    constructor() { 
        
        CompetitionUpdateCompetitionParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompetitionUpdateCompetitionParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompetitionUpdateCompetitionParam} obj Optional instance to populate.
     * @return {module:model/CompetitionUpdateCompetitionParam} The populated <code>CompetitionUpdateCompetitionParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompetitionUpdateCompetitionParam();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
CompetitionUpdateCompetitionParam.prototype['name'] = undefined;






export default CompetitionUpdateCompetitionParam;

